import { render } from "./raceScale.vue?vue&type=template&id=15126906&scoped=true"
import script from "./raceScale.vue?vue&type=script&lang=js"
export * from "./raceScale.vue?vue&type=script&lang=js"

import "./raceScale.vue?vue&type=style&index=0&id=15126906&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15126906"]])

export default __exports__